import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { Button } from '../Button';
export var StyledClearIconButton = styled(Button.IconOnly)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 24px;\n\theight: 24px;\n"])));